import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (window.rails_env == "development") {
      return
    }

    // We start by waiting 3 seconds. This will give enough time to Rewardful
    // to fully load.
    setTimeout(function() {
      // If Rewardful failed to load, we do not proceed.
      if (typeof Rewardful == "undefined") {
        return
      }

      if (Rewardful.referral == "") {
        return
      }

      let data = { referral_code: Rewardful.referral }

      fetch("/users/referral-code", {
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
        },
        body: JSON.stringify(data),
      })
    }, 3000)
  }
}
